import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import { DataTableRow } from 'components/dataTable';
import DataTable from 'components/dataTable/dataTable';
import { TableFilters } from 'components/filters/table/tableFilters';
import { TableFiltersProps } from 'components/filters/table/types';
import { SearchInput } from 'components/inputs/search/search';

import { TablePagination } from 'types/pagination';
import { TableSorting } from 'types/sort';

import { CustomerTableCell } from './components/customerTableCell';
import { COLUMNS, LABELS } from './keys';
import { ActionBar, Container } from './styles';
import { CustomerDataRow, Filters } from './types';
import { makeFilterSections } from './utils';

interface OrderListPageProps {
  orders: CustomerDataRow[];
  isLoading: boolean;
  pagination: TablePagination;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (itemsPerPage: number) => void;
  onSort: (event: MouseEvent, property: string) => void;
  sorting: TableSorting;
  onSearch: (value: string) => void;
  search: string;
  filterProps: TableFiltersProps<Filters>;
  onRowClick: (row: DataTableRow) => void;
}

export const CustomersList = ({
  orders,
  isLoading,
  pagination,
  onChangePage,
  onChangeRowsPerPage,
  onSort,
  sorting,
  onSearch,
  search,
  filterProps,
  onRowClick,
}: OrderListPageProps) => {
  const { t } = useTranslation();

  const sections = makeFilterSections(filterProps.filterSettings);

  return (
    <Panel>
      <Container>
        <SearchInput search={search} onSearch={onSearch} placeholder={t(LABELS.SEARCH_PLACEHOLDER)} />
        <ActionBar>
          <TableFilters {...filterProps} sections={sections} />
        </ActionBar>
        <DataTable
          columns={COLUMNS}
          rows={orders}
          loading={isLoading}
          CellComponent={CustomerTableCell}
          pagination={pagination}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onSort={onSort}
          order={sorting.order}
          orderBy={sorting.orderBy}
          onRowClick={onRowClick}
        />
      </Container>
    </Panel>
  );
};
